export default __webpack_public_path__ + "static/last-word_view-msg_banner_mobile-1fdd5be7d84f69d7a1773aebd27cb951.png";